import React from 'react';
import { Helmet } from 'react-helmet-async';
import CommonHeader from '../Components/Headers/CommonHeader';
import ProfileAreaContent from '../Components/ProfileArea/ProfileAreaContent';
import { userAppContext } from '../Context/Context';
import NotLoginPage from '../Components/ProfileArea/NotLoginPage';

const ProfileArea = () => {
  const { authorization, isAuthenticated } = userAppContext();

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Profile Area</title>
        <meta name="description" content="Manage your DISGENET profile." />
      </Helmet>
      <CommonHeader />
      {!isAuthenticated ? <NotLoginPage /> : <ProfileAreaContent />}
    </React.Fragment>
  );
};

export default ProfileArea;
